import React from 'react';
import { useAuth } from '../../contexts/AuthContext';
import './Header.css';
import { FiSidebar, FiMaximize2, FiMenu } from 'react-icons/fi';
import { useTenantName } from '../../hooks/useTenantName';
import { useLocation } from 'react-router-dom';

type HeaderProps = {
    sidebarCollapsed: boolean;
    onToggleSidebar: () => void;
    onMobileMenuToggle?: () => void;
};

export function Header({ sidebarCollapsed, onToggleSidebar, onMobileMenuToggle }: HeaderProps) {
    const { fullName } = useAuth();
    const tenantName = useTenantName();
    const location = useLocation();

    const contextLabel = React.useMemo(() => {
        if (location.pathname.startsWith('/pos')) {
            return 'POS Touch';
        }
        return null;
    }, [location.pathname]);

    const displayTitle = contextLabel ? (
        <div className="header-title-cluster">
            <span className="header-tenant-name">{tenantName}</span>
            <span className="header-divider">/</span>
            <span className="header-context">{contextLabel}</span>
        </div>
    ) : (tenantName);

    const ToggleIcon = sidebarCollapsed ? FiMaximize2 : FiSidebar;

    return (
        <header className="main-header">
            <div className="header-left">
                <button
                    type="button"
                    className="header-mobile-menu-toggle"
                    onClick={onMobileMenuToggle}
                    aria-label="Apri menu"
                    title="Apri menu"
                >
                    <FiMenu />
                </button>
                <button
                    type="button"
                    className="header-sidebar-toggle"
                    onClick={onToggleSidebar}
                    aria-pressed={sidebarCollapsed}
                    aria-label={sidebarCollapsed ? 'Espandi menu principale' : 'Riduci menu principale'}
                    title={sidebarCollapsed ? 'Espandi menu principale' : 'Riduci menu principale'}
                >
                    <ToggleIcon />
                </button>
                <h1 className="header-main-title">{displayTitle || 'Tenant Portal'}</h1>
            </div>
            <div className="header-right">
                <div className="user-profile">
                    <span>{fullName || 'Utente'}</span>
                </div>
            </div>
        </header>
    );
}
